import * as React from 'react';
import usersReducer from './usersReducer.js';
import { UsersContext } from './usersContext.js';

function UsersProvider({ children }) {
  
  const [state, dispatch] = React.useReducer(usersReducer, {
    allUsers: [],
    allPartners: [],
    allStaff: [],
    newUser: {},
    loggedUser: {},
    isLoading: false,
    allClinicPartners: []
  });

  const value = [state, dispatch];

  return (
    <UsersContext.Provider value={value}>
      { children }
    </UsersContext.Provider>
  )
}

export default UsersProvider;

